import React from 'react';
import { Box, Card, CardContent, Typography, Button, AppBar, Toolbar } from '@mui/material';
import { TextField } from '@mui/material';
import { CircularProgress } from '@mui/material';
import axios from 'axios';

export default function Dashboard() {
	const [source, setSource] = React.useState('');
	const [destination, setDestination] = React.useState('');
	const [sourceError, setSourceError] = React.useState('');
	const [destinationError, setDestinationError] = React.useState('');
  const [loading, setLoading] = React.useState(false);

	function isValidUrl(url) {
		if (typeof url !== 'string') return false;
		const trimmed = url.trim();
		if (trimmed.startsWith('/') && trimmed.length > 1) return true;
		try {
			new URL(trimmed);
			return true;
		} catch {
			return false;
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		let valid = true;
		if (!source.trim()) {
			setSourceError('Source is required');
			valid = false;
		} else if (!isValidUrl(source.trim())) {
			setSourceError('Source must be a valid URL');
			valid = false;
		} else {
			setSourceError('');
		}
		if (!destination.trim()) {
			setDestinationError('Destination is required');
			valid = false;
		} else if (!isValidUrl(destination.trim())) {
			setDestinationError('Destination must be a valid URL');
			valid = false;
		} else {
			setDestinationError('');
		}
		if (valid) {
			try {
        setLoading(true);
				const response = await axios.get('https://38g7bbcol8.execute-api.us-east-1.amazonaws.com/prod/get')
				const responseBody = response?.data?.body
        const parsedPresigned = JSON.parse(responseBody)
				// Fetch the JSON from the presigned URL
				const jsonResponse = await axios.get(parsedPresigned.url)
				const redirectsJSON = jsonResponse.data
				console.log('Fetched JSON: => ', redirectsJSON)
        const newEDPRedirect = { source: source?.trim(), destination: destination?.trim(), permanent: true }
        redirectsJSON.push(newEDPRedirect)
        console.log('Updated JSON with new redirect:', redirectsJSON)

        const postResponse = await axios.post('https://38g7bbcol8.execute-api.us-east-1.amazonaws.com/prod/update')
				const postResponseBody = postResponse?.data?.body
        const parsedPostPresigned = JSON.parse(postResponseBody)

        const postDataResponse = await axios.put(parsedPostPresigned.url, JSON.stringify(redirectsJSON, null, 2), {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        console.log('Upload success:', postDataResponse.status);
        setLoading(false);
        setDestination('')
        setSource('')
				// You can now use jsonData as needed
			} catch (error) {
				console.error('Error fetching JSON from presigned URL:', error)
        setLoading(false);
        setDestination('')
        setSource('')
			}
		}
	};

  const handleInvalidate = async () => {
    setLoading(true);
    const response = await axios.get('https://38g7bbcol8.execute-api.us-east-1.amazonaws.com/prod/invalidate')
    const responseBody = response?.data?.body
    console.log('Invalidate response:', responseBody)
    setLoading(false);
  }

	return (
		<Box sx={{ flexGrow: 1, minHeight: '100vh' }}>
			<AppBar style={{ backgroundColor: 'rgb(42, 45, 59)'}} position="static" elevation={0}>
					<Box sx={{ flexGrow: 1, bgcolor: '#f5f6fa', minHeight: '100vh' }}>
						<AppBar position="static" style={{ backgroundColor: 'rgb(42, 45, 59)'}} elevation={0}>
							<Toolbar>
								<img src="https://platform-assets.msg.com/event-engine/qsfgugeu976wahdripa4.svg" alt='msg-logo' />
								</Toolbar>
						</AppBar>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '80vh', pt: 6 }}>
							<Typography color='black' variant="h4" component="h4" gutterBottom sx={{ mb: 4 }}>
								Update past EDPs with redirects
							</Typography>
							<Card sx={{ minWidth: '80%', boxShadow: 3, mb: 4 }}>
								<CardContent>
                  {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '120px' }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <form onSubmit={handleSubmit} noValidate>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <TextField
                          label="Source"
                          name="source"
                          variant="outlined"
                          fullWidth
                          required
                          value={source}
                          onChange={e => setSource(e.target.value)}
                          error={!!sourceError}
                          helperText={sourceError}
                        />
                        <TextField
                          label="Destination"
                          name="destination"
                          variant="outlined"
                          fullWidth
                          required
                          value={destination}
                          onChange={e => setDestination(e.target.value)}
                          error={!!destinationError}
                          helperText={destinationError}
                        />
												<Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
													<Button style={{
														color: '#fff',
														backgroundColor: '#0078d4',
														border: '1px solid transparent',
														width: '160px',
														height: '38px',
														padding: '15px 20px',
														justifyContent: 'center',
														alignItems: 'center',
														gap: '10px',
													}} type="submit" variant="contained" color="primary">Add</Button>
													<Button style={{
														color: '#fff',
														backgroundColor: '#d40078',
														border: '1px solid transparent',
														width: '160px',
														height: '38px',
														padding: '15px 20px',
														justifyContent: 'center',
														alignItems: 'center',
														gap: '10px',
													}} onClick={handleInvalidate} type="button" variant="contained" color="secondary">Invalidate</Button>
												</Box>
                      </Box>
                    </form>
                  )}
								</CardContent>
							</Card>
						</Box>
					</Box>
        </AppBar>
    </Box>
  );
}
